<script setup>
import { useHttp } from "vutil";
import { ref } from "vue";

const props = defineProps(["charger"]);
const emit = defineEmits(["close", "update"]);

const { busy, error, patch, del } = useHttp(() => emit("update"));
const name = ref(props.charger.name);
const reserved = ref(props.charger.reserved);
</script>

<template>
	<UiDialog :modal="busy" @close="$emit('close')">
		<h1>Ladepunkt</h1>
		<form @submit.prevent="patch(`/api/charger/${charger.id}`, { name: name || null, reserved })">
			<fieldset :disabled="busy">
				<label for="name">Navn</label>
				<input id="name" v-model.trim="name" type="text">
				<div class="ui-hint">Valgfritt ladepunkt navn/nummer/merkelapp</div>
				<input id="reserved" v-model="reserved" type="checkbox">
				<label for="reserved">Reserver laderen til eget bruk</label>
				<div class="error">{{ error }}</div>
				<div class="btn-row">
					<button type="submit" class="ui">Lagre</button>
					<button type="button" class="ui outlined" @click="del(`/api/charger/${charger.id}`)">Slett</button>
				</div>
			</fieldset>
		</form>
	</UiDialog>
</template>
